export interface DeploymentTemplateDefinition {
  id: string;
  name: string;
  description: string;
  target: string;
  gateway_mode: string;
  template: string;
}

export const SHARED_GATEWAY_LOCAL_TEMPLATE = `# Docker Compose — Shared Gateway (Local)
# Generated by Augmented

services:
  gateway:
    image: {{ gateway.image | default("ghcr.io/openclaw/gateway:latest") }}
    ports:
      - "{{ gateway.port }}:8080"
    environment:
      - AUGMENTED_MODE=shared
      - AUGMENTED_AGENTS={% for a in agents %}{{ a.code_name }}{% if not loop.last %},{% endif %}{% endfor %}
{% for agent in agents %}
  {{ agent.code_name }}:
    image: {{ variables.agent_image | default("ghcr.io/openclaw/agent:latest") }}
    environment:
      - AGENT_ID={{ agent.agent_id }}
      - AGENT_CODE_NAME={{ agent.code_name }}
      - GATEWAY_URL=http://gateway:8080
      - ENVIRONMENT={{ agent.environment }}
    depends_on:
      - gateway
{% endfor %}`;

export const DEDICATED_GATEWAY_LOCAL_TEMPLATE = `# Docker Compose — Dedicated Gateway per Agent (Local)
# Generated by Augmented

services:
{% for agent in agents %}
  gateway-{{ agent.code_name }}:
    image: {{ gateway.image | default("ghcr.io/openclaw/gateway:latest") }}
    ports:
      - "{{ agent.port | default(gateway.port + loop.index0) }}:8080"
    environment:
      - AUGMENTED_MODE=dedicated
      - AUGMENTED_AGENT={{ agent.code_name }}

  {{ agent.code_name }}:
    image: {{ variables.agent_image | default("ghcr.io/openclaw/agent:latest") }}
    environment:
      - AGENT_ID={{ agent.agent_id }}
      - AGENT_CODE_NAME={{ agent.code_name }}
      - GATEWAY_URL=http://gateway-{{ agent.code_name }}:8080
      - ENVIRONMENT={{ agent.environment }}
    depends_on:
      - gateway-{{ agent.code_name }}
{% endfor %}`;

export const DEPLOYMENT_TEMPLATES: DeploymentTemplateDefinition[] = [
  {
    id: 'shared-gateway-local',
    name: 'Shared Gateway (Local Docker)',
    description: 'One gateway endpoint; N agents route to it. Best for governance and simplest ops.',
    target: 'local_docker',
    gateway_mode: 'shared',
    template: SHARED_GATEWAY_LOCAL_TEMPLATE,
  },
  {
    id: 'dedicated-gateway-local',
    name: 'Dedicated Gateway per Agent (Local Docker)',
    description: 'Each agent has its own gateway instance on a unique port. Best for isolation and debugging.',
    target: 'local_docker',
    gateway_mode: 'dedicated',
    template: DEDICATED_GATEWAY_LOCAL_TEMPLATE,
  },
];

export function getTemplate(id: string): DeploymentTemplateDefinition | undefined {
  return DEPLOYMENT_TEMPLATES.find((t) => t.id === id);
}
